// extracted by mini-css-extract-plugin
export default {"status":"SheetStatus_status_cnNlf"};